// extracted by mini-css-extract-plugin
module.exports = {"headerCont":"dashHeader_headerCont__33Z3r","link":"dashHeader_link__3UwRW"};